<div class="w-full h-screen grid grid-cols-2">
  <div class="flex flex-col h-full w-full items-center">
    <div class="flex-1 flex flex-col justify-center items-center w-4/7">

      <div class="flex flex-col self-start">
        <h1 class="text-3xl font-semibold mb-6 text-left">Restablecer contraseña</h1>
      </div>

      <form [formGroup]="form" autocomplete="off" class="flex flex-col gap-6 w-full">
        <!-- Formulario de envío de correo para recuperación de contraseña -->
        @if (step === 1) {
          <div class="text-gray-600">
            <p>Proporcione la dirección de correo electrónico asociada con su cuenta.</p>
            <p>Le enviaremos un código de verificación a esa dirección.</p>
          </div>

          <div class="flex flex-col">
            <label for="email">Correo electrónico*</label>
            <input
              pInputText
              fluid
              id="email"
              formControlName="email"
              placeholder="Ingrese su correo electrónico"
              [invalid]="isInvalid('email')"
            />
            <p-message severity="error" size="small" variant="simple">
              {{ getErrorMessage('email') }}
            </p-message>
          </div>

          <p-button
            severity="primary"
            type="button"
            (onClick)="onSubmitEmail()"
            [loading]="isLoading"
            fluid
          >
            <span>Enviar código</span>
          </p-button>
        }

        <!-- Formulario posterior a envío de correo para ingresar código de verificación -->
        @else if (step === 2) {
          <div class="text-gray-600">
            <p>Se le ha enviado un código de recuperación a su correo.</p>
            <p>Revise su bandeja de entrada o en la carpeta de correo no deseado.</p>
          </div>

          <div class="flex flex-col">
            <label for="verificationCode">Código de verificación*</label>
            <input
              pInputText
              fluid
              id="verificationCode"
              formControlName="verificationCode"
              placeholder="Ingrese el código de verificación"
              [invalid]="isInvalid('verificationCode')"
            />
            <p-message severity="error" size="small" variant="simple">
              {{ getErrorMessage('verificationCode') }}
            </p-message>
          </div>

          <p-button
            severity="primary"
            type="button"
            (onClick)="onSubmitVerificationCode()"
            [loading]="isLoading"
            fluid
          >
            <span>Enviar código</span>
          </p-button>
        }

        <!-- Formulario para restablecer la contraseña -->
        @else {
          <div class="text-gray-600">
            <p>Escriba la nueva contraseña para dar ingreso a su cuenta.</p>
            <p>Esta debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un símbolo.</p>
          </div>
  
          <div class="flex flex-col">
            <label for="password">Contraseña*</label>
            <p-password
              fluid
              id="password" 
              formControlName="password" 
              [toggleMask]="true" 
              [feedback]="false"
              placeholder="Ingrese su contraseña"
              [invalid]="isInvalid('password')"/>
            <p-message severity="error" size="small" variant="simple">
              {{ getErrorMessage('password') }}
            </p-message>
          </div>
  
          <div class="flex flex-col">
            <label for="confirmPassword">Confirmar contraseña*</label>
            <p-password
              fluid
              id="confirmPassword" 
              formControlName="confirmPassword" 
              [toggleMask]="true" 
              [feedback]="false"
              placeholder="Ingrese nuevamente su contraseña"
              [invalid]="isInvalid('confirmPassword')"/>
            <p-message severity="error" size="small" variant="simple">
              {{ getConfirmPasswordErrorMessage('confirmPassword') }}
            </p-message>
          </div>
  
          <p-button
            severity="primary"
            type="button"
            (onClick)="onSubmitConfirmPassword()"
            [loading]="isLoading"
            fluid
          >
            <span>Restablecer contraseña</span>
          </p-button>
        }
      </form>

      <div class="flex justify-center gap-4 mt-4">
        <p-button label="Regresar al inicio de sesión" link (onClick)="redirectToLogin()" />
      </div>
    </div>

    <app-footer />
  </div>

  <div>
    <img src="assets/images/login/background.jpg" class="w-full h-full object-cover" />
  </div>
</div>

<app-dialog
  [(visible)]="visibleEmailSentDialog"
  type="info"
  title="Verifique su bandeja de entrada"
  [message]="[
    `Revise su bandeja de entrada (y también en carpeta de correo no deseado) 
    para encontrar el correo electrónico de restablecemiento de contraseña.`,
    `El correo electrónico contendrá un código de verificación para continuar 
    con el proceso.`
  ]"
  buttonText="Continuar"
  (onButtonClick)="onCloseEmailSentDialog()">
</app-dialog>

<app-dialog
  [(visible)]="visibleFinishedDialog"
  type="info"
  title="Contraseña restablecida"
  [message]="[
    `¡Su contraseña ha sido restablecida con éxito!`,
    `Ahora puede acceder a su cuenta con su nueva contraseña.`,
    `Si necesita más ayuda, no dude en contactarnos.`
  ]"
  buttonText="Continuar"
  (onButtonClick)="onCloseFinishedDialog()">
</app-dialog>
